/* eslint-disable @typescript-eslint/no-unused-vars */


import React, { useCallback, useLayoutEffect, useMemo, useRef } from 'react';
import './CustomNocLineGraph.css';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

interface ICustomNocLineGraphProps {
    plotData: ICustomLinePlotData[] | null;
    yAxisLabel: string;
    tooltipLabel: string;
    unit?:string;
}


const CustomNocLineGraph: React.FC<ICustomNocLineGraphProps> = (props) => {
    const { plotData, yAxisLabel, tooltipLabel,unit } = props;
    const chartRef = useRef<HighchartsReact.RefObject>(null);
    const [chartSize, setChartSize] = React.useState<{ width: number | null, height: number | null }>({ width: null, height: 180 });
    const chartWrapRef = useRef<HTMLDivElement>(null);


    const getFormattedData = useCallback(() => {
        const xAxis = plotData?.map(data => data?.hour)
        const yAxis = plotData?.map(data => data?.count)
        return { xAxis, yAxis }
    }, [plotData])


    const { xAxis, yAxis } = getFormattedData();


    const options: Highcharts.Options = useMemo(() =>
    ({
        chart: {
            type: 'line',
            backgroundColor: 'transparent',
            height: chartSize?.height ?? 180,
            width: chartSize?.width,
            margin:[20, 20, 30, 50],   
        },
        title: { text: undefined },
        subtitle: { text: undefined },
        xAxis: {
            title: {
                text: undefined,
            },
            labels: {
                style: {
                    fontSize: '10px',
                    color: '#000'
                },
                step: 5
            },
            gridLineDashStyle: 'ShortDash',
            categories: xAxis,
            lineColor: '#06BFBF',

        },
        yAxis: {
            title: {
                text: yAxisLabel + (!unit ? '' :` (${unit})`),
                style: {
                    fontSize: '12px',
                    color: '#000'
                    // fontWeight: 'bold'
                }
            },
            labels: {
                style: {
                    fontSize: '10px',
                    color: '#000'
                    // fontWeight:'bold'  
                },
            },
            gridLineDashStyle: 'ShortDash',
            min: 0,
        },
        tooltip:{
            formatter: function () {
                const point = this.point;
                const value = this.y;
                
                const category: string = this.x as string;
                const endMeridian = category?.split(' ')?.[1];
                const endTime = category?.split(' ')?.[0];
                const startTime = parseInt(endTime) === 1 ? 12 : parseInt(endTime) - 1;
                const startMeridian = endTime === '12' ? endMeridian === 'AM' ? 'PM' : 'AM' : endMeridian ;
                
                return `
                    <span>${startTime}:00 ${startMeridian} - ${endTime}:00 ${endMeridian}</span>
                    <br/>
                    <span>
                        <span style='color:${point.color}'>\u25CF</span>${tooltipLabel} : <span style='font-weight:bold; white-space: nowrap'>${value} ${unit? unit : ''}</span></span>
                `;
            }
        },
        series: [
            {
                name: '',
                type: 'spline',
                data: yAxis,
                color: '#06BFBF',
                marker: {
                    enabled: false,
                    states: {
                        hover: {
                            enabled: true
                        }
                    }
                }
            }
        ],
        credits: { enabled: false },
        exporting: { enabled: false },
    }), [chartSize,plotData])

    // Observes the parent container for resizing and change the chart height and width accordingly
    useLayoutEffect(() => {
        if (!chartWrapRef.current) return;

        const observer = new ResizeObserver(() => {
            const { width, height } = chartWrapRef.current!.getBoundingClientRect();
            setChartSize({ width: width - 20 , height: height - 20 });
        });

        observer.observe(chartWrapRef.current);

        return () => observer.disconnect();
    }, []);


    return (
        <div className="noc-dashboard-custom-line-graph-wrap" ref={chartWrapRef}>
            <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
        </div>
    )
}


export default CustomNocLineGraph;

